<template>
  <div class="page">
     <div class="pagebanner pagebanner1" :style="{background:'url('+pagebanner+') center 0 no-repeat'}">
      <div class="w1200">
        <h1 class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0">{{pagetitle}}</h1>
        <span class="bounceInUp wow" data-wow-duration="1s" data-wow-delay="0.2s">{{pagedesc}}</span>
      </div>
    </div>
    <div class="page-location">
      <div class="w1200">
        <ul class="pagenav">
          <li>
            <a href="javascript:;" @click="$router.push({name: 'environment'})">{{ $t('anquanhuanbao')}}</a>
          </li>
          <li class="s">
            <a href="javascript:;" @click="$router.push({name: 'welfare'})">{{ $t('welfare')}}</a>
          </li>
          <li>
            <a href="javascript:;" @click="$router.push({name: 'care'})">{{ $t('care')}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="welfare-box1">
      <div class="w1200">
        <div class="welfare-box1-title">
          <h1>{{ $t('welfaretexta')}}</h1>
          <span>{{ $t('welfaretextb')}}</span>
        </div>
        <ul class="welfare-box1-list">
          <li v-for="(item ,index) in contributionarr" :key="index">
            <div class="zhedang">
              {{item.describe}}
            </div>
            <div class="pic">
              <img :src="item.image" alt="">
            </div>
            <h1>{{item.title}}</h1>
            <span>{{item.sub_title}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="welfare-box2">
      <div class="w1200">
        <div class="welfare-box2-title">
          {{ $t('welfaredesc')}}
        </div>
        <ul class="welfare-box2-list">
          <li v-for="(item ,index) in strivearr" :key="index">{{item.title}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Fetch from '../js/ajax'
export default {
  name: 'Environment',
  metaInfo () {
    return {
      meta: [{
        name: 'keywords',
        content: '浙江金科日化原料有限公司,氧系漂白助剂过碳酸钠,SPC'
      }]
    }
  },
  data () {
    return {
      pagetitle: '',
      pagedesc: '',
      pagebanner: '',
      contributionarr: [],
      strivearr: []
    }
  },
  mounted () {
  },
  methods: {
  },
  created () {
    const that = this
    Fetch.post('Api/column', {
      id: 5
    }).then((res) => {
      that.pagetitle = res.result.title
      that.pagedesc = res.result.sub_title
      that.pagebanner = res.result.image
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/contribution', {
    }).then((res) => {
      that.contributionarr = res.result
    }).catch(err => {
      console.log(err)
    })
    Fetch.post('Api/strive', {
    }).then((res) => {
      that.strivearr = res.result
    }).catch(err => {
      console.log(err)
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page-main{
    min-height: 400px;
    padding: 0 40px;
    overflow: hidden;
  }
  .pagebanner{
    height: 600px;
    overflow: hidden;
  }
  .pagebanner5{
    background: url(../assets/pagebanner5.png) center 0 no-repeat;
  }
  .pagebanner h1{
    height: 60px;
    display: block;
    line-height: 60px;
    margin-top: 271px;
    text-align: center;
    font-size: 40px;
    font-weight: bold;
    color: #fff;
  }
  .pagebanner span{
    overflow: hidden;
    height: 41px;
    display: block;
    line-height: 41px;
    text-align: center;
    font-size: 20px;
    color: #fff;
  }
  .page-location{
    height: 60px;
    background-color: #F4F4F4;
  }
  .pagenav{
    width: 100%;
    height: 60px;
    display: flex;
    justify-content:center;
  }
  .pagenav li{
    min-width: 168px;
    height: 60px;
  }
  .pagenav li a{
    display: block;
    width: auto;
    height: 100%;
    padding: 0 5px;
    line-height: 60px;
    text-align: center;
    color: #999999;
    margin: 0 5px;
    font-size: 14px;
  }
  .pagenav .s a,.pagenav li:hover a{
    color: #E40A1F;
    font-size: 16px;
    font-weight: bold;
    background-color: #fff;
  }
  .welfare-box1{
    min-height: 686px;
    padding-bottom: 30px;
  }
  .welfare-box1-title{
    width: 100%;
    height: auto;
    line-height: 76px;
    margin-top: 75px;
  }
  .welfare-box1-title h1{
    display: block;
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-weight: bold;
    color: #E40A1F;
    line-height: 30px;
    font-size: 20px;
  }
  .welfare-box1-title span{
    display: block;
    width: 100%;
    height: auto;
    line-height: 22px;
    text-align: center;
    font-weight: bold;
    color: #2A2431;
    margin-top: 24px;
  }
  .welfare-box1-list{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
  }
  .welfare-box1-list li{
    width: 580px;
    height: auto;
    overflow: visible;
    position: relative;
  }
  .welfare-box1-list li .pic{
    width: 100%;
    height: 287px;
    overflow: hidden;
    margin-top: 35px;
  }
  .welfare-box1-list li .pic img{
    width: 100%;
    height: auto;
  }
  .welfare-box1-list li h1{
    display: block;
    width: 100%;
    height: 29px;
    margin-top: 33px;
    font-size: 20px;
    font-weight: bold;
    color: #333333;
  }
  .welfare-box1-list li span{
    display: block;
    width: 100%;
    line-height: 30px;
    margin-top: 33px;
    font-weight: bold;
    color: #333333;
    margin-top: 11px;
  }
  .welfare-box1-list li .zhedang{
    width: 580px;
    height: auto;
    background: #FFFFFF;
    box-shadow: 0px 10px 18px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    border:1px solid #fff;
    position: absolute;
    box-sizing: border-box;
    padding: 10px 20px;
    top: 0;
    left: 0;
    overflow-y: auto;
    display: none;
  }
  .welfare-box1-list li:hover .zhedang{
    display: block;
    border-left:1px solid rgba(104, 104, 104, 0.1);
    box-shadow: 0px 10px 18px 0px rgba(0, 0, 0, 0.1);
  }
  .welfare-box2{
    height: auto;
    box-sizing: border-box;
    padding-top: 46px;
    min-height: 250px;
    padding-bottom: 30px;
    background: #f9f9f9 url(../assets/xisd_dx.png) center 0 no-repeat;
  }
  .welfare-box2-title{
    font-weight: bold;
    color: #E40A1F;
    font-size:30px;
    height: 49px;
    text-align: center;
  }
  .welfare-box2-list{
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 30px;
  }
  .welfare-box2-list li{
    width: 50%;
    height: 58px;
    box-sizing: border-box;
    padding-left: 68px;
    display: flex;
    align-items: center;
    color: #333;
  }
  .welfare-box2-list li::before{
    content: "";
    width: 4px;
    height: 14px;
    background: #E40A1F;
    margin-right: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/welfare.vue